import classnames from 'classnames';
import React from 'react';
import { useQuery } from 'react-query';
import { Button, FormGroup } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { RootState } from 'v2/models';
import checkIconFilledGreen from '../../../icons/checkIconFilledGreen.svg';
import crossIconFilled from '../../../icons/crossIconFilledRed.svg';
import styles from './subscription.module.scss';
import { getPermissionData, PERMISSION_NAME } from 'v2/utils/permissions';
import { isSubscriptionOwner } from 'v2/utils/user';
import { SubscriptionNotifications } from './SubscriptionNotifications/SubscriptionNotifications';

interface SubscriptionManagementProps {
  isLoading: boolean;
  onManage: () => void;
}

const SubscriptionManagement = ({
  isLoading,
  onManage,
}: SubscriptionManagementProps) => {
  const user = useSelector((state: RootState) => state.user.user);
  const permissions = useSelector(
    (state: RootState) => state.permissions.permissions
  );
  const permissionList = getPermissionData(permissions, [
    PERMISSION_NAME.CREATE_SEARCH,
  ]);
  const {
    data: isSubcriptionOwnerData,
    isSuccess: isSubcriptionOwnerIsSuccess,
  } = useQuery('isSubcriptionOwner', async () => isSubscriptionOwner(user));
  const isSubscriptionReady =
    isSubcriptionOwnerIsSuccess &&
    isSubcriptionOwnerData &&
    permissionList.at(0)?.subscription_chargebee_id &&
    !isLoading;

  return (
    <>
      <FormGroup className="mb-5">
        <label>Subscription Status:</label>
        <div className="d-flex align-items-center">
          <img
            className={classnames('mr-1', styles.iconStatus)}
            src={
              permissionList.at(0)?.subscription_active
                ? checkIconFilledGreen
                : crossIconFilled
            }
            alt="statusIcon"
          ></img>
          <p className="m-0">
            {permissionList.at(0)?.subscription_active ? 'Active' : 'Inactive'}
          </p>
        </div>
      </FormGroup>

      {isSubscriptionReady ? (
        <>
          <p>Click below to manage your subscription</p>
          <div>
            <Button onClick={onManage}>Manage Subscription</Button>
          </div>
        </>
      ) : null}
      <div className={classnames(styles.formGrid, 'mt-5 mb-4')}>
        <SubscriptionNotifications />
      </div>
    </>
  );
};

export default SubscriptionManagement;
